<footer class="bg-slate-50 shadow-lg">
  <div class="container px-6 py-10 mx-auto">
    <div class="text-center">
      <a routerLink="">
        <img class="mx-auto w-52 mb-10" src="assets/img/logo_preto.svg" alt="AngolaEncontra"/>
      </a>

      <p class="text-sm max-w-md mx-auto text-black ">AngolaEncontra, a maior plataforma
        nacional para encontrar tudo o que perdeu.</p>

      <div class="flex flex-col md:space-x-5 mt-4 sm:flex-row sm:items-center sm:justify-center">
        <a routerLink="ocorrencias" [queryParams]="{padrao:'vehicle'}" class="text-sm mx-2 text-gray-500">Veículos</a>
        <a routerLink="ocorrencias" [queryParams]="{padrao:'people'}" class="text-sm mx-2 text-gray-500">Pessoas</a>
        <a routerLink="ocorrencias" [queryParams]="{padrao:'document'}" class="text-sm mx-2 text-gray-500">Documentos</a>
        <a routerLink="ocorrencias" [queryParams]="{padrao:'other'}" class="text-sm mx-2 text-gray-500">Outros</a>
      </div>
    </div>

    <hr class="my-8 border border-gray-200"/>

    <div class="flex flex-col items-center sm:flex-row sm:justify-between">
      <p class="text-sm text-gray-400">Copyright © 2026 AngolaEncontra. Todos os direitos reservados.</p>

      <div class="flex mt-3 -mx-2 sm:mt-0">
        <a routerLink="/termos" class="mx-2 text-sm text-gray-400 hover:text-gray-500"
           aria-label="Reddit"> Termos de Uso e Politicas de Privacidade</a>

      </div>
    </div>
  </div>
</footer>
